import { create } from "zustand"

export type AnimationType = "burn" | "break"
export type ChessColor = "black" | "white"

export interface ChessAnimation {
    row: number
    col: number
    type: AnimationType
    color: ChessColor
    id: string // 唯一标识
}

interface AnimationState {
    activeAnimations: Map<string, ChessAnimation> // key: `${row}-${col}`
}

interface AnimationActions {
    playBurnAnimation: (row: number, col: number, color: ChessColor) => void
    playBreakAnimation: (row: number, col: number, color: ChessColor) => void
    removeAnimation: (key: string) => void
    clearAll: () => void
}

export const useAnimationStore = create<AnimationState & AnimationActions>(
    (set, get) => ({
        activeAnimations: new Map(),

        // 播放燃烧动画
        playBurnAnimation: (row, col, color) => {
            const key = `${row}-${col}`
            const id = `burn-${Date.now()}-${Math.random()}`

            set((state) => {
                const newMap = new Map(state.activeAnimations)
                newMap.set(key, { row, col, type: "burn", color, id })
                return { activeAnimations: newMap }
            })
        },

        // 播放破碎动画
        playBreakAnimation: (row, col, color) => {
            const key = `${row}-${col}`
            const id = `break-${Date.now()}-${Math.random()}`

            set((state) => {
                const newMap = new Map(state.activeAnimations)
                newMap.set(key, { row, col, type: "break", color, id })
                return { activeAnimations: newMap }
            })
        },

        // 移除动画
        removeAnimation: (key) => {
            set((state) => {
                const newMap = new Map(state.activeAnimations)
                newMap.delete(key)
                return { activeAnimations: newMap }
            })
        },

        // 清空所有动画
        clearAll: () => {
            set({ activeAnimations: new Map() })
        },
    })
)
